import { DEFAULT_ITEM_SIZE } from '@repo/common/components/MultiSelector/constants';
import { map, noop } from 'lodash-es';
import { useMemo } from 'react';
import { useCollectionListAll, type ISecodaEntity } from '../../api';
import type { PropertySelectorProps } from './PropertySelector';
import { PropertySelector } from './PropertySelector';

export interface CollectionsPropertySelectorProps
	extends Pick<
		PropertySelectorProps,
		'onChange' | 'position' | 'withinPortal'
	> {
	entity: ISecodaEntity;
	viewerOfEntity: boolean;
	preventNavigate?: boolean;
	noMaxHeightDropdown?: boolean;
}

export function CollectionsPropertySelector({
	entity,
	viewerOfEntity,
	preventNavigate = false,
	withinPortal,
	noMaxHeightDropdown = false,
	...propertySelectorProps
}: CollectionsPropertySelectorProps) {
	const { data: collections } = useCollectionListAll();

	const collectionOptions = useMemo(
		() =>
			map(collections?.results, (collection) => ({
				label: collection.title || 'Untitled',
				value: collection.id,
				icon: collection.icon,
				navigateTo: preventNavigate
					? undefined
					: `/collections/${collection.id}`,
				onClick: noop,
			})),
		[collections, preventNavigate]
	);

	return (
		<PropertySelector
			selected={entity?.collections}
			type="multi"
			value="collections"
			iconType="emoji"
			options={collectionOptions}
			isViewerUser={viewerOfEntity}
			readOnly={viewerOfEntity}
			placeholder={viewerOfEntity ? 'No collections' : 'Add to collection'}
			placeholderIconName="folder"
			withinPortal={withinPortal}
			noMaxHeightDropdown={noMaxHeightDropdown}
			virtuosoHeight={`min(70vh, ${(collectionOptions.length || 8) * DEFAULT_ITEM_SIZE}px)`}
			{...propertySelectorProps}
		/>
	);
}
